import {
  type Log,
  LogLevels,
  type LoggerConfiguration,
  type LogLevel as OurLogLevel,
} from '@backmarket/front-logger'
import { LogLevel, faro } from '@grafana/faro-web-sdk'

import { flattenAttributes } from './flattenAttributes'

const faroLogLevels: Record<OurLogLevel, LogLevel> = {
  [LogLevels.DEBUG]: LogLevel.DEBUG,
  [LogLevels.INFO]: LogLevel.INFO,
  [LogLevels.ERROR]: LogLevel.ERROR,
}

export function createFaroTransport({
  level,
}: { level?: OurLogLevel } = {}): LoggerConfiguration['transports'][number] {
  return {
    level,
    name: 2,
    log(transformedLog: Log) {
      // The Faro singleton is initialised by nuxt-module-instrumentation's
      // client plugin, which runs after the logger plugin. Guard against the
      // window check (SSR safety) and against the logger emitting before Faro
      // has finished initialising.
      if (typeof window === 'undefined') return
      if (!faro?.api) return

      const logLevel = LogLevels[transformedLog.SeverityText]
      const context = flattenAttributes(transformedLog.Attributes)

      if (logLevel === LogLevels.ERROR && transformedLog.error) {
        // pushError sends a dedicated error event with a full stack trace,
        // which Grafana surfaces separately from log lines. We still call
        // pushLog below so the error also appears in the log stream with its
        // structured context.
        const { name, message, stack, cause } = transformedLog.error
        const error = Object.assign(new Error(message), { name, stack, cause })
        faro.api.pushError(error, { context })
      }

      faro.api.pushLog([transformedLog.Body], {
        level: faroLogLevels[logLevel],
        context,
      })
    },
  }
}
